import { render, staticRenderFns } from "./modalCedis.vue?vue&type=template&id=0be9d8b6&"
import script from "./modalCedis.vue?vue&type=script&lang=js&"
export * from "./modalCedis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports